import { createUseStyles } from "react-jss";
import { breakpoints } from "../../../constants/breakpoints";
import {colors} from "../../../constants/colors";

const styles = createUseStyles(theme => ({
  modalContent: {
    margin: "20px 0 0 0"
  },
  icon: {
    "& rect": {
      fill: theme.modal.selectedOption.icon.fill,
    },
    "& path": {
      stroke: theme.modal.selectedOption.icon.stroke,
    }
  },
  footerBtns: {
    display: "flex",
    justifyContent: "center",
    width: "100%",
    fontSize: "16px",
    fontWeight: "600",
    lineHeight: "24px"
  },
  checkbox: {
    marginRight: "12px",
    cursor: "pointer"
  },
  modal: {
    width: "480px",
    "& .modal-header": {
      padding: "24px 24px 20px",
      "& div": {
        height: "46px",
        padding: "10px",
        "& svg": {
          display: "flex"
        }
      },
      "& button": {
        fontSize: "14px",
        position: "absolute",
        top: "32px",
        right: "32px"
      }
    },
    "& .modal-title": {
      padding: "0 24px"
    },
    "& .modal-body": {
      padding: "8px 24px",
      fontSize: "14px",
      fontWeight: "400",
      lineHeight: "20px"
    },
    "& .modal-footer": {
      padding: "24px 24px"
    },
    "& .modal-footer>*": {
      margin: "0px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto"
    }
  },
  cancelBtn: {
    extend: "footerBtns",
  },
  cancelBtnCol: {
    paddingRight: "6px"
  },
  saveBtn: {
    extend: "footerBtns",
  },
  saveBtnCol: {
    paddingLeft: "6px"
  },
  colorsmodalContent: {
    margin: "22px 0 0 0",
    display: "flex",
    flexDirection: "column",
    gap: "14px",
    "& .form-check-input:checked" : {
      // outline: "1px solid " + colors.darkBlue,
    }
  },
  optionContainer:{
    display:"flex",
    flexDirection:"row",
    border: "1px solid " + colors.lightGrey,
    borderRadius: "12px",
    padding: "16px",
    marginBottom:"12px",
    cursor: "pointer",
    "& h3":{
      fontSize:"14px",
      fontWeight:"500",
      lineHeight:"20px",
      color: colors.grey,
      margin:"0px"
    },
    "& p":{
      fontSize:"14px",
      fontWeight:"400",
      lineHeight:"20px",
      color: colors.mediumGrey,
      margin:"0px"
    },
    "& input":{
      appearance: "none",
      width: "16px",
      height: "16px",
      border: "1px solid " + colors.lightGrey,
      borderRadius: "8px",
      cursor: "pointer",
      "&:checked": {
        backgroundColor: theme.colors.primary,
        backgroundImage: theme.icon.checkIcon,
        backgroundSize: "9px",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundOrigin:"content-box",
        border: "1px solid" + theme.colors.primary,
      }
    },
    "&:hover": {
      border:  "1px solid " +  theme.modal.selectedOption.hoverBackgroundColor
    }
  },
  selectedOptionContainer:{
    border: theme.modal.selectedOption.border,
    backgroundColor: theme.modal.selectedOption.backgroundColor,
    color: theme.modal.selectedOption.text.color,
    padding: "15px",
    "& h3":{
      color: theme.modal.selectedOption.text.color
    },
    "& p":{
      color: theme.modal.selectedOption.text.color
    },
    "&:hover": {
      border:  "2px solid " +  theme.modal.selectedOption.hoverBackgroundColor
    }
  },
  logo:{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "32px",
    height: "32px",
    borderRadius:"16px",
  },
  textContainer:{
    marginLeft:"16px",
    marginRight:"4px"
  },

}));

export default styles;
